import { render } from "./Facilittes.vue?vue&type=template&id=46fd38a7&scoped=true&ts=true"
import script from "./Facilittes.vue?vue&type=script&lang=ts"
export * from "./Facilittes.vue?vue&type=script&lang=ts"

import "./Facilittes.vue?vue&type=style&index=0&id=46fd38a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fd38a7"]])

export default __exports__